
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lang/[locale]/school-and-free-plan",
      function () {
        return require("private-next-pages/lang/[locale]/school-and-free-plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lang/[locale]/school-and-free-plan"])
      });
    }
  